import { render } from "./desulDenitrification.vue?vue&type=template&id=01324091&scoped=true"
import script from "./desulDenitrification.vue?vue&type=script&lang=js"
export * from "./desulDenitrification.vue?vue&type=script&lang=js"

import "./desulDenitrification.vue?vue&type=style&index=0&id=01324091&lang=scss"
import "./desulDenitrification.vue?vue&type=style&index=1&id=01324091&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01324091"]])

export default __exports__